import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import moment from 'moment';

moment.updateLocale('ru', {
  months: ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'],
});

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { PagesModule } from './pages/pages.module';
import { AppUiModule } from './ui/app-ui.module';
import { ngBootstrapConfigProvider } from './ui/ng-bootstrap-config';
import { SharedModule } from './shared/shared.module';

import { CookieService } from 'ngx-cookie-service';
import { httpInterceptorProviders } from './interceptors/httpInterceptorProviders';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule, CommonModule, FormsModule, ReactiveFormsModule, AppRoutingModule,
    PagesModule, AppUiModule, SharedModule, BrowserAnimationsModule,
  ],
  providers: [CookieService, httpInterceptorProviders, ngBootstrapConfigProvider, provideHttpClient(withXhr(), withInterceptorsFromDi())],
  bootstrap: [AppComponent],
})
export class AppModule {}
